import { atom } from 'recoil';

export const authModalControl = atom<{
  login: boolean;
  signUp: boolean;
  forgotPassword: boolean;
  bookId: string;
  comingSoon: string;
  noRedirect: boolean;
  headingCopy?: string;
  subHeadingCopy?: string;
  amazonOrderId?: string;
  email?: string;
  name?: string;
  fullname?: string;
  phone?: string;
  phoneCountryCode?: string;
  phonePrefix?: string;
  emailExistsMessage?: boolean;
}>({
  key: 'authModalControl',
  default: {
    login: false,
    signUp: false,
    forgotPassword: false,
    bookId: '',
    comingSoon: '',
    noRedirect: false,
    headingCopy: '',
    subHeadingCopy: '',
    amazonOrderId: '',
    email: '',
    name: '',
    fullname: '',
    phone: '',
    phoneCountryCode: '',
    phonePrefix: '',
    emailExistsMessage: false,
  },
});

export const tokenUpdate = atom<boolean>({
  key: 'tokenUpdate',
  default: false,
});
